module.exports = __webpack_public_path__ + "static/media/delete-icon.50b5cb3c.svg";